// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/user_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_user_user } from "../model/user/user_pb";

/**
 * Describes the file proto/service/user_service.proto.
 */
export const file_proto_service_user_service = /*@__PURE__*/
  fileDesc("CiBwcm90by9zZXJ2aWNlL3VzZXJfc2VydmljZS5wcm90bxIGY2FybWVuIi8KEUNyZWF0ZVVzZXJSZXF1ZXN0EhoKBHVzZXIYASABKAsyDC5jYXJtZW4uVXNlciIwChJDcmVhdGVVc2VyUmVzcG9uc2USGgoEdXNlchgBIAEoCzIMLmNhcm1lbi5Vc2VyIjUKDkdldFVzZXJSZXF1ZXN0EiMKCXVzZXJfcGF0aBgBIAEoCzIQLmNhcm1lbi5Vc2VyUGF0aCItCg9HZXRVc2VyUmVzcG9uc2USGgoEdXNlchgBIAEoCzIMLmNhcm1lbi5Vc2VyIoUBChFVcGRhdGVVc2VyUmVxdWVzdBIjCgl1c2VyX3BhdGgYASABKAsyEC5jYXJtZW4uVXNlclBhdGgSGgoEdXNlchgCIAEoCzIMLmNhcm1lbi5Vc2VyEi8KC3VwZGF0ZV9tYXNrGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayIwChJVcGRhdGVVc2VyUmVzcG9uc2USGgoEdXNlchgBIAEoCzIMLmNhcm1lbi5Vc2VyIjgKEURlbGV0ZVVzZXJSZXF1ZXN0EiMKCXVzZXJfcGF0aBgBIAEoCzIQLmNhcm1lbi5Vc2VyUGF0aCIlChJEZWxldGVVc2VyUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCDKYAgoLVXNlclNlcnZpY2USQwoKQ3JlYXRlVXNlchIZLmNhcm1lbi5DcmVhdGVVc2VyUmVxdWVzdBoaLmNhcm1lbi5DcmVhdGVVc2VyUmVzcG9uc2USOgoHR2V0VXNlchIWLmNhcm1lbi5HZXRVc2VyUmVxdWVzdBoXLmNhcm1lbi5HZXRVc2VyUmVzcG9uc2USQwoKVXBkYXRlVXNlchIZLmNhcm1lbi5VcGRhdGVVc2VyUmVxdWVzdBoaLmNhcm1lbi5VcGRhdGVVc2VyUmVzcG9uc2USQwoKRGVsZXRlVXNlchIZLmNhcm1lbi5EZWxldGVVc2VyUmVxdWVzdBoaLmNhcm1lbi5EZWxldGVVc2VyUmVzcG9uc2VCKlooZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vc2VydmljZWIGcHJvdG8z", [file_google_protobuf_field_mask, file_proto_model_core_model_path, file_proto_model_user_user]);

/**
 * Describes the message carmen.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 0);

/**
 * Describes the message carmen.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 1);

/**
 * Describes the message carmen.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 2);

/**
 * Describes the message carmen.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 3);

/**
 * Describes the message carmen.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 4);

/**
 * Describes the message carmen.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 5);

/**
 * Describes the message carmen.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 6);

/**
 * Describes the message carmen.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_user_service, 7);

/**
 * @generated from service carmen.UserService
 */
export const UserService = /*@__PURE__*/
  serviceDesc(file_proto_service_user_service, 0);

